/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Center_LeftInputs */

const en_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Center Left`)
};

const fr_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner au centre gauche`)
};

const de_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Mitte Links`)
};

const it_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione Centro Sinistra`)
};

const ru_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Центр слева`)
};

const es_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición Centro Izquierda`)
};

const zh_cn2_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：中左`)
};

const ja_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置中央左`)
};

const hi_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति केंद्र बाएँ`)
};

const pt_pt2_shortcut_keys_name_cc_position_center_left = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição Central Esquerda`)
};

/**
* | output |
* | --- |
* | "Position Center Left" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Center_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_center_left = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Center_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_position_center_left(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_position_center_left(inputs)
	return en_shortcut_keys_name_cc_position_center_left(inputs)
});